import React, { lazy } from 'react';

// CX-4788: single unified screen (status dropdown swaps Draft/Posted/Cancelled).
const ACExportDetailsForm = lazy(() => import('./ACExportDetailsForm'));

const ROOT = '/gl-interface';
const DETAILS = `${ROOT}/ac-export-details`;

export const AcExportPaths = {
  ROOT,
  LISTING: DETAILS,
} as const;

const acExportRoutes = [
  {
    props: { exact: true, path: AcExportPaths.LISTING },
    component: <ACExportDetailsForm />,
  },
];

export default acExportRoutes;
